import * as Slider from '@radix-ui/react-slider';

interface SliderFieldProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function SliderField({
  label,
  value,
  min,
  max,
  step = 1,
  unit = '',
  onChange,
  disabled = false,
}: SliderFieldProps) {
  return (
    <div className="flex items-center gap-4">
      <span className="w-16 shrink-0 text-sm text-text-secondary">{label}</span>
      <span className="w-14 shrink-0 rounded-md border border-surface-border bg-surface-2 px-2 py-1 text-center text-sm text-text-primary">
        {value}
        {unit}
      </span>
      <Slider.Root
        min={min}
        max={max}
        step={step}
        value={[value]}
        disabled={disabled}
        onValueChange={(nextValue) => onChange(nextValue[0] ?? value)}
        className="relative flex h-5 flex-1 touch-none select-none items-center disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Slider.Track className="relative h-1.5 flex-1 overflow-hidden rounded-full bg-surface-3">
          <Slider.Range className="absolute h-full bg-accent" />
        </Slider.Track>
        <Slider.Thumb
          aria-label={label}
          className="block h-4 w-4 rounded-full bg-text-primary shadow-sm outline-none transition-colors focus-visible:ring-2 focus-visible:ring-accent"
        />
      </Slider.Root>
    </div>
  );
}
